import {
  DataGrid,
  GridCellParams,
  GridColDef,
  GridSelectionModel,
} from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import { Item } from '../../utils/sharedTypes';
import { useFindAllSoftwareLinksQuery } from '../../api/api-hooks';
import { SoftwareLink } from '../../api/api-generated';
import { filterSoftwareLink } from './linksUtils';
import { SoftwareLinksFilter } from './linksTypes';
import LinkNewTab from '../../components/LinkNewTab';

interface Props {
  setSelectedLinks: React.Dispatch<React.SetStateAction<Item[]>>;
  filters: SoftwareLinksFilter;
}

const SoftwareVersionsTable = ({ setSelectedLinks, filters }: Props) => {
  const { data: links } = useFindAllSoftwareLinksQuery({});
  if (links === undefined) return <CircularProgress></CircularProgress>;
  // Define data for display in DataGrid
  const columns: GridColDef[] = [
    { field: 'id', hide: true },
    { field: 'link', hide: true },
    {
      field: 'name',
      headerName: 'Documentation Name',
      width: 280,
      renderCell: (params: GridCellParams) => (
        <LinkNewTab href={params.row.link} label={params.row.name} />
      ),
    },
    { field: 'software', headerName: 'Software', width: 180 },
  ];
  const rows = links
    .filter((link) => filterSoftwareLink(link, filters))
    .map((item: SoftwareLink) => ({
      id: item.id,
      name: item.name,
      link: item.link,
      software: item.software.type,
    }));
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedLinks(
      links.filter((link: SoftwareLink) => model.includes(link.id))
    );
  };
  return (
    <>
      <div style={{ paddingBottom: '1rem', width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={100}
          checkboxSelection
          disableSelectionOnClick
          autoHeight
          disableColumnMenu={true}
          onSelectionModelChange={handleTableSelection}
        />
      </div>
    </>
  );
};

export default SoftwareVersionsTable;
